import StockTickerTabs from './StockTickerTabs';

export default StockTickerTabs;
